import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "overflow-hidden rounded-[10px] bg-white shadow-sm ring-1 ring-gray-300",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "flex items-center gap-[5px] border-b border-gray-200 bg-[#eef1f5] px-2.5 py-[7px]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }

import { computed } from 'vue'


export default {
  __name: 'LeadCapturePreview',
  props: {
  headline: { type: String, default: '' },
  description: { type: String, default: '' },
  logoUrl: { type: String, default: null },
  consentText: { type: String, default: '' },
  pageUrl: { type: String, default: null },
  brandColor: { type: String, default: null },
  collectEmail: { type: Boolean, default: true },
  size: { type: String, default: 'mini' }
},
  setup(__props) {

const SIZES = {
  mini: {
    url: 'text-[9.5px] leading-tight',
    page: 'px-3 py-3',
    card: 'p-2.5',
    cardWidth: 'max-w-[228px]',
    header: 'gap-1.5',
    logo: 'h-7',
    headline: 'text-[11px]',
    description: 'text-[7.5px]',
    descriptionSpace: 'mt-0.5',
    fields: 'mt-2.5 gap-1.5',
    label: 'text-[7.5px]',
    labelSpace: 'mb-0.5',
    nameGap: 'gap-1',
    field: 'h-3.5',
    button: 'h-5',
    buttonText: 'text-[8px]',
    consent: 'text-[5.5px]'
  },
  full: {
    url: 'text-xs leading-tight',
    page: 'px-4 py-6',
    card: 'p-6',
    cardWidth: 'max-w-md',
    header: 'gap-3',
    logo: 'h-14',
    headline: 'text-2xl leading-8',
    description: 'text-sm',
    descriptionSpace: 'mt-2',
    fields: 'mt-6 gap-4',
    label: 'text-sm',
    labelSpace: 'mb-2',
    nameGap: 'gap-2',
    field: 'h-10',
    button: 'h-12',
    buttonText: 'text-sm',
    consent: 'text-xs'
  }
}

const props = __props

const s = computed(() => SIZES[props.size] ?? SIZES.mini)
const brandStyle = computed(() =>
  props.brandColor ? { backgroundColor: props.brandColor, borderColor: props.brandColor } : null
)
const addressBarUrl = computed(
  () => (props.pageUrl ?? '').replace(/^https?:\/\//, '') || 'your-store.bottle.com/join-our-list'
)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (dot) => {
        return _createElementVNode("span", {
          key: dot,
          class: "h-[7px] w-[7px] shrink-0 rounded-full bg-gray-300"
        })
      }), 64)),
      _createElementVNode("span", {
        class: _normalizeClass(["ml-2 min-w-0 flex-1 truncate rounded-full bg-white px-2.5 py-0.5 text-gray-400", s.value.url])
      }, _toDisplayString(addressBarUrl.value), 3)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["bg-gray-brand-100", s.value.page])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["mx-auto rounded-lg border border-gray-200 bg-white shadow-sm", [s.value.card, s.value.cardWidth]])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col items-center text-center", s.value.header])
        }, [
          (__props.logoUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.logoUrl,
                alt: "",
                class: _normalizeClass(["w-auto max-w-full object-contain", s.value.logo])
              }, null, 10, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["font-bold leading-tight tracking-tighter text-gray-brand-900", s.value.headline])
            }, _toDisplayString(__props.headline), 3),
            (__props.description)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["whitespace-pre-line leading-normal text-gray-brand-700", [s.value.description, s.value.descriptionSpace]])
                }, _toDisplayString(__props.description), 3))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col", s.value.fields])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["font-bold text-gray-brand-900", [s.value.label, s.value.labelSpace]])
            }, "Your name", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["grid grid-cols-2", s.value.nameGap])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rounded border border-gray-300 bg-white", s.value.field])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["rounded border border-gray-300 bg-white", s.value.field])
              }, null, 2)
            ], 2)
          ]),
          (__props.collectEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["font-bold text-gray-brand-900", [s.value.label, s.value.labelSpace]])
                }, "Email", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["rounded border border-gray-300 bg-white", s.value.field])
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["font-bold text-gray-brand-900", [s.value.label, s.value.labelSpace]])
            }, "Mobile number", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["rounded border border-gray-300 bg-white", s.value.field])
            }, null, 2)
          ]),
          _createElementVNode("div", {
            "data-preview-button": "",
            class: _normalizeClass(["flex items-center justify-center rounded-lg border font-semibold text-white", [s.value.button, s.value.buttonText, __props.brandColor ? '' : 'border-brand-600 bg-brand-500']]),
            style: _normalizeStyle(brandStyle.value)
          }, " Join our list ", 6),
          (__props.consentText)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["text-center leading-normal text-gray-brand-600", s.value.consent])
              }, _toDisplayString(__props.consentText), 3))
            : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ], 2)
  ]))
}
}

}